<template>
  <el-dialog destroy-on-close title="媒体预览" :visible.sync="dialogVisible" width="500px">
    <div class="flex flex-all-center">
      <audio v-if="row&& type==='audio'" :src="row.url[0].url" controls></audio>
      <video width="100%" height="500px" v-else-if="row&& type==='video'" :src="row.url[0].url" controls></video>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "player",
  data() {
    return {
      dialogVisible: false,
      row: undefined,
      type: undefined
    };
  },
  methods: {
    show(row, type) {
      this.row = row;
      this.type = type;
      this.dialogVisible = true;
    }
  }
};
</script>

<style scoped>
</style>